import { Systemtittel } from "nav-frontend-typografi";
import Panel from "nav-frontend-paneler";
import * as React from 'react';
export default {
  Systemtittel,
  Panel,
  React
};